import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import RichTextRenderer from 'components/RichTextRenderer';
import useSearchMatches from 'products/nomad_insurance/views/Policy/hooks/useSearchMatches';
import CostCoverage from '../CostCoverage';
import {
  StyledAddon,
  TitleContainer,
  AddonIcon,
  AddonTitle,
  AddonName,
  AddonContent
} from './styled';

const Addon = ({ addon }) => {
  const { isSearchMatch } = useSearchMatches(useMemo(() => [addon], [addon]));

  if (!isSearchMatch) return null;

  return (
    <StyledAddon>
      <TitleContainer>
        <AddonIcon>
          <img
            src={addon.fields.icon.fields.file.url}
            alt={`${addon.fields.name} icon`}
          />
        </AddonIcon>
        <div>
          <AddonTitle>Add-on</AddonTitle>
          <AddonName>{addon.fields.name}</AddonName>
        </div>
      </TitleContainer>
      <AddonContent>
        <RichTextRenderer richText={addon.fields.content} />
      </AddonContent>
      <CostCoverage
        safetyWingCovers={addon.fields.safetyWingCovers}
        youCover={addon.fields.youCover}
      />
    </StyledAddon>
  );
};

Addon.propTypes = {
  addon: PropTypes.object.isRequired
};

export default Addon;
